import { Elements } from '@stripe/react-stripe-js';
import { Stripe } from '@stripe/stripe-js';
import React from 'react';

export default function StripeProvider(props: {
  stripe: Promise<Stripe | null>;
  children: React.ReactNode;
}) {
  return <Elements stripe={props.stripe}>{props.children}</Elements>;
}
